export default __webpack_public_path__ + "static/media/atom.adab7492.png";